import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Navbar, Sidebar } from "./components";
import {
  Home,
  Notices,
  Galleries,
  Calendar,
  Members,
  Funds,
  Profiles,
  Feedbacks,
  Login,
  Logout,
  Events,
  Helplines,
  Letters,
  Notfound,
} from "./pages";

import { useStateContext } from "./contexts/ContextProvider";
import { AuthProvider } from "./pages/Auth/AuthContext";
import ProtectedRoute from "./pages/Auth/ProtectedRoute";

const Layout = ({ children }) => {
  const { activeMenu, currentMode } = useStateContext();

  return (
    <div className={`flex relative ${currentMode === "Dark" ? "dark" : ""}`}>
      {/* Sidebar */}
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}

      {/* Main Content */}
      <div
        className={`dark:bg-main-dark-bg bg-main-bg min-h-screen w-full ${
          activeMenu ? "md:ml-72" : "flex-2"
        }`}
      >
        {/* Navbar */}
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
          <Navbar />
        </div>

        {/* Page Content */}
        <div className="mt-16">{children}</div>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Route */}
          <Route path="/" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Layout>
                  <Home />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notices"
            element={
              <ProtectedRoute>
                <Layout>
                  <Notices />
                </Layout>
              </ProtectedRoute>
            }
          />
             <Route
            path="/galleries"
            element={
              <ProtectedRoute>
                <Layout>
                  <Galleries />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/events"
            element={
              <ProtectedRoute>
                <Layout>
                  <Events />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/funds"
            element={
              <ProtectedRoute>
                <Layout>
                  <Funds />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/members"
            element={
              <ProtectedRoute>
                <Layout>
                  <Members />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedbacks"
            element={
              <ProtectedRoute>
                <Layout>
                  <Feedbacks />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/members/profiles/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <Profiles />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/helplines"
            element={
              <ProtectedRoute>
                <Layout>
                  <Helplines />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <Layout>
                  <Calendar />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/letters"
            element={
              <ProtectedRoute>
                <Layout>
                  <Letters />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Logout Route */}
          <Route path="/logout" element={<Logout />} />

          {/* Fallback Route */}
          <Route path="*" element={<Notfound />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
